import ResultRepository from './ResultRepository'

const resource = '/sample-results'

export default {
  getAll(params) {
    return ResultRepository.get(`${resource}?limit=all`, { params })
  },

  get(id, params) {
    return ResultRepository.get(`${resource}/${id}`, { params })
  },

  getTimeSeriesReport(payload) {
    return ResultRepository.post(`${resource}/time-series`, payload)
  }
}